import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { Specializations } from '@/models/specializations';
import {Filter} from "@/types/filter/filter";
import filterModel from "@/store/specializations/filterModel";
import SpecializationsFilter from "@/store/specializations/filterEntity";

export const MODULE_NAME = Specializations.moduleName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class SpecializationsModule extends PageBaseModule {
    filter: Filter;

    constructor(module: SpecializationsModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(Specializations.listTitle);
        page.setTitleAdd(Specializations.createTitle);
        page.values.actionPagination = 'specializations/updatePage';
        page.values.actionPageAmountItems = 'specializations/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Specializations.moduleName}_edit`;
        this.pageSettings.routeParam = `${Specializations.moduleName}Id`;

        const filter = new filterModel();
        this.filter = getModule(SpecializationsFilter);
        this.filter.setFilterName('specializationsFilter');
        this.filter.setTemplateClassName('template-lg directory-filters');
        this.filter.setFilterModel(filter.filterModel);
        this.filter.setFilterHandlers(filter.filterHandlers);
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(
                Specializations.apiPrefix,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            await this.context.dispatch('setList', result.table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(SpecializationsModule);
